var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6733V7.34001M8 5.34001V5.33334M6.26667 14H9.73333C11.2268 14 11.9735 14 12.544 13.7094C13.0457 13.4537 13.4537 13.0457 13.7094 12.544C14 11.9735 14 11.2268 14 9.73333V6.26667C14 4.77319 14 4.02646 13.7094 3.45603C13.4537 2.95426 13.0457 2.54631 12.544 2.29065C11.9735 2 11.2268 2 9.73333 2H6.26667C4.77319 2 4.02646 2 3.45603 2.29065C2.95426 2.54631 2.54631 2.95426 2.29065 3.45603C2 4.02646 2 4.77319 2 6.26667V9.73333C2 11.2268 2 11.9735 2.29065 12.544C2.54631 13.0457 2.95426 13.4537 3.45603 13.7094C4.02646 14 4.77319 14 6.26667 14Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewInfoIcon);
export default __webpack_public_path__ + "static/media/preview-info-icon.c4a470e94eae88505d79989ef11bcb51.svg";
export { ForwardRef as ReactComponent };